import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { UnsupportedComponent } from './unsupported/unsupported.component';
import { TooManyRequestsComponent } from './too-many-requests/too-many-requests.component';
import { TooManyIcpGrundstueckRequestsComponent } from './too-many-icp-grundstueck-requests/too-many-icp-grundstueck-requests.component';
import { Routes } from '@angular/router';

export const SecurityRoutes: Routes = [
  {
    path: 'security',
    component: AppDeciderComponent,
    children: [
      {
        path: 'forbidden',
        component: ForbiddenComponent
      },
      {
        path: 'unsupported',
        component: UnsupportedComponent
      },
      {
        path: 'toomanyrequests',
        component: TooManyRequestsComponent
      },
      {
        path: 'toomanyicpgrundstueckrequests',
        component: TooManyIcpGrundstueckRequestsComponent
      }
    ]
  }
];
